import styled, { css } from 'styled-components';

// Import styles
import { scroll, media, flex } from 'components/styles';

// Import components
import { Heading } from 'components/elements';

export const Item = styled.div`
	height: ${({ height }) => height}px;
	width: ${({ width }) => width}px;
	background: transparent;

	${({ image }) =>
		image &&
		css`
			background:
				linear-gradient(0deg, rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0.55)),
				url(${image}) no-repeat;
			background-size: cover;
		`}
`;

export const Content = styled.div`
	${flex({ fd: 'column', jc: 'space-between' })}
	width: 100%;
	height: 100%;
	padding: 1rem 0.5rem;
`;

export const HeadingThirdStyled = styled(Heading.Third)`
	text-align: center;
	font-weight: ${({ theme }) => theme.font.normal};
	margin-bottom: 0.5rem;
`;

export const Paragraph = styled.p`
	font-size: 1rem;
	color: ${({ theme }) => theme.white};
	opacity: 0.7;
	text-align: center;
	padding: 0 0.5rem;
	overflow-y: scroll;
	${scroll({ thumb: 'whiteSemiTranslucent', scrollbarWidth: 7 })};

	${media.min.medium(css`
		font-size: 1.2rem;
		padding: 0 1rem;
	`)}
	${media.min.max(css`
		font-size: 1.4rem;
		padding: 0 2rem;
	`)}
`;

export const ButtonWrapper = styled.div`
	width: auto;
`;
